import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/solutions")({
  head: () => buildRouteHead("/solutions", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/solutions", replace: true });
  },
});
